
import { useState, useCallback } from 'react';
import { 
  createOrder, 
  CreateOrderData, 
  OrderResult, 
  getOrderById, 
  getOrderByNumber,
  updateOrderStatus,
  bulkUpdateOrderStatus
} from '@/services/orderService';

export const useOrderManagement = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const createNewOrder = useCallback(async (orderData: CreateOrderData): Promise<OrderResult> => {
    setIsCreating(true);
    try {
      const result = await createOrder(orderData);
      return result;
    } finally {
      setIsCreating(false);
    }
  }, []);

  const fetchOrder = useCallback(async (orderId: string) => {
    setIsFetching(true);
    try {
      const result = await getOrderById(orderId);
      return result;
    } finally {
      setIsFetching(false);
    }
  }, []);

  const fetchOrderByNumber = useCallback(async (orderNumber: string) => {
    setIsFetching(true);
    try {
      const result = await getOrderByNumber(orderNumber);
      return result;
    } finally {
      setIsFetching(false);
    }
  }, []);

  const updateOrderStatusById = useCallback(async (orderId: string, status: string) => {
    setIsUpdating(true);
    try {
      const result = await updateOrderStatus(orderId, status);
      return result;
    } finally {
      setIsUpdating(false);
    }
  }, []);

  const bulkUpdateOrders = useCallback(async ({ orderIds, status }: { orderIds: string[], status: string }) => {
    setIsUpdating(true);
    try {
      const result = await bulkUpdateOrderStatus(orderIds, status);
      return result;
    } finally {
      setIsUpdating(false);
    }
  }, []);

  return {
    createNewOrder,
    fetchOrder,
    fetchOrderByNumber,
    updateOrderStatus: updateOrderStatusById,
    bulkUpdateOrders,
    isCreating,
    isFetching,
    isUpdating
  };
};
